import React, { forwardRef } from 'react'

import { BaseIconButton, type BaseIconButtonProps } from './BaseIconButton'

interface IconLinkProps
  extends Omit<BaseIconButtonProps, 'children'>, Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'className' | 'children'> {
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export const IconLink = forwardRef<HTMLAnchorElement, IconLinkProps>(
  ({ disabled, ...props }, forwardedRef) => {
    return (
      <BaseIconButton {...props}>
        <a
          aria-disabled={disabled}
          href={disabled ? undefined : props.href}
          onClick={
            disabled
              ? (event) => {
                  event.preventDefault()
                }
              : props.onClick
          }
          ref={forwardedRef}
          tabIndex={disabled ? -1 : undefined}
        />
      </BaseIconButton>
    )
  }
)
